module.exports = __webpack_public_path__ + "img/avatar-man.c4feb4f9.svg";